<template>

  <v-app-bar light dense xs12 app>
    <v-app-bar-nav-icon
      v-if="!_drawer"
      @click.stop="_drawer = !_drawer">
    </v-app-bar-nav-icon>

    <v-toolbar-title class="mr-3">
      <slot name="header">Header</slot>
    </v-toolbar-title>

    <slot name="toolbar-items"></slot>

  </v-app-bar>
</template>

<script>

	import {mdiBottleTonicPlus, mdiHospitalBoxOutline} from '@mdi/js'

	import {
		VAppBar, VAppBarNavIcon, VToolbarTitle, VIcon
	} from 'vuetify'
	import format from "string-format"


	export default {
		name: "main-bar",
		components: {
			VAppBar, VAppBarNavIcon, VToolbarTitle, VIcon
		},
		data: function () {
			return {
				// drawer: false,
			}
		},
		props: {
			drawer: {
				type: Boolean,
				default: false
			},
		},
		computed: {
			_drawer: {
				get: function () {
					return this.drawer
				},
				set: function (value) {
					// console.debug(format("MainBarComponent.set_drawer({0})", value))
					this.$emit('drawer_change', value)
				}
			}
		}
	}
</script>

<style scoped>

</style>